<template>
  <b-form-group>
    <template #label>
      <span>{{ $t(label) }}</span>
      <span v-if="required && label" class="text-danger">*</span>
    </template>
    <b-input-group
      v-bind:class="{ 'is-valid': state, 'is-invalid': state == false }"
    >
      <b-form-input
        v-model="contentText"
        type="text"
        placeholder="DD/MM/AAAA"
        autocomplete="off"
        :state="state"
        :disabled="disabled"
        @input="handleTextInput"
        @blur="handleBlur"
        maxlength="10"
      ></b-form-input>
      <b-form-datepicker
        v-model="content"
        :state="state"
        :disabled="disabled"
        @input="handleDatepickerInput"
        button-only
        right
        label-help=""
        label-no-date-selected="Nenhuma data selecionada"
      />
      <b-form-invalid-feedback>{{ feedback }}</b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
import mensagem from '@/common/utils/mensagem';
export default {
  name: 'InputDateOnlyBtn',
  props: {
    value: { type: [String, Date], default: '' },
    label: { type: String, required: false },
    required: { type: Boolean },
    requiredMessage: { type: String },
    disabled: { type: Boolean, default: false },
    dataPassado: { type: Boolean, default: false },
  },
  data() {
    return {
      content: '',
      contentText: '',
      validarFormulario: false,
      hasError: false,
      erroData: false,
      errorMessage: 'Data inválida',
      isUpdatingFromDatepicker: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newData) {
        if (!newData) {
          this.contentText = '';
          this.content = '';
          return;
        }

        let date;
        if (typeof newData === 'string' && newData.includes('-')) {
          const [year, month, day] = newData.split('-');
          date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        } else {
          date = new Date(newData);
        }
        
        if (isNaN(date.getTime())) {
          this.contentText = '';
          this.content = '';
          return;
        }

        this.contentText = this.formatDateToBr(date);
        this.content = this.formatDateToEn(date);
      },
    },
    erroData() {
      if (this.erroData == true) {
        mensagem.erro(
          'Data Inválida!',
          'A data selecionada deve ser anterior à data atual.'
        );
      }
    },

  },
  computed: {
    requiredValid() {
      return !(this.required && !this.value);
    },
    state() {
      if (!this.validarFormulario) return null;
      if (!this.requiredValid || this.erroData) return false;
      return true;
    },
    feedback() {
      if (!this.validarFormulario) return '';
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.REQUERIDO').formatUnicorn({
            name: this.$t(this.label),
          })
        );
      if (this.hasError) {
        return this.errorMessage;
      }
      return '';
    },
  },
  methods: {
    isValidDate(dateString) {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const match = dateString.match(regex);
      
      if (!match) return false;
      
      const [, day, month, year] = match;
      const date = new Date(year, month - 1, day);
      
      return date.getDate() == day &&
             date.getMonth() == month - 1 &&
             date.getFullYear() == year;
    },

    convertBrToEn(dateBr) {
      if (!this.isValidDate(dateBr)) return null;
      
      const [day, month, year] = dateBr.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    formatDateToBr(date) {
      if (!date) return '';
      return new Intl.DateTimeFormat('pt-BR').format(date);
    },

    formatDateToEn(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    handleTextInput() {
      if (this.isUpdatingFromDatepicker) return;
      
      const input = this.$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      
      let value = this.contentText.replace(/\D/g, '');
      
      if (value.length > 8) {
        value = value.substring(0, 8);
      }
      
      let maskedValue = '';
      if (value.length >= 1) maskedValue += value.substring(0, 1);
      if (value.length >= 2) maskedValue += value.substring(1, 2);
      if (value.length >= 2) maskedValue += '/';
      if (value.length >= 3) maskedValue += value.substring(2, 3);
      if (value.length >= 4) maskedValue += value.substring(3, 4);
      if (value.length >= 4) maskedValue += '/';
      if (value.length >= 5) maskedValue += value.substring(4, 5);
      if (value.length >= 6) maskedValue += value.substring(5, 6);
      if (value.length >= 7) maskedValue += value.substring(6, 7);
      if (value.length >= 8) maskedValue += value.substring(7, 8);
      
      this.contentText = maskedValue;
      
      if (value.length === 0) {
        this.content = '';
        this.hasError = false;
        this.emitData();
      }
      
      this.$nextTick(() => {
        let newPosition = cursorPosition;
        
        if (value.length >= 2 && cursorPosition > 2) {
          newPosition++;
        }
        if (value.length >= 4 && cursorPosition > 4) {
          newPosition++;
        }
        
        newPosition = Math.min(newPosition, maskedValue.length);
        input.setSelectionRange(newPosition, newPosition);
      });
    },

    validateAndConvertDate() {
      if (this.contentText.length !== 10) {
        this.hasError = false;
        return;
      }

      if (!this.isValidDate(this.contentText)) {
        this.hasError = true;
        this.content = '';
        this.emitData();
        return;
      }

      const dateEn = this.convertBrToEn(this.contentText);
      if (dateEn) {
        this.content = dateEn;
        this.hasError = false;
        this.validarDataPassado();
        this.emitData();
      }
    },

    handleBlur() {
      if (this.contentText.length === 10) {
        this.validateAndConvertDate();
      }
    },

    handleDatepickerInput() {
      this.isUpdatingFromDatepicker = true;
      
      if (this.content) {
        const [year, month, day] = this.content.split('-');
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        this.contentText = this.formatDateToBr(date);
        this.hasError = false;
        this.validarDataPassado();
        this.emitData();
      } else {
        this.contentText = '';
        this.hasError = false;
        this.emitData();
      }
      
      this.$nextTick(() => {
        this.isUpdatingFromDatepicker = false;
      });
    },

    validarDataPassado() {
      if (this.dataPassado && this.content) {
        const dataSelecionada = new Date(this.content);
        const dataAtual = new Date();
        dataAtual.setHours(0, 0, 0, 0); 
        
        if (dataSelecionada > dataAtual) {
          this.hasError = true;
          this.erroData = true;
        } else {
          this.hasError = false;
          this.erroData = false;
        }
      }
    },

    converteDataBrEn(dataBR) {
      return this.convertBrToEn(dataBR);
    },
    
    converteDataEnBr() {
      if (this.content) {
        const date = new Date(this.content);
        this.contentText = this.formatDateToBr(date);
      }
    },
    
    alteraFormatoDataDB(dataVindoDaDB) {
      const date = new Date(dataVindoDaDB);
      this.contentText = this.formatDateToBr(date);
    },
    
    formatarData(data) {
      return data ? data.substring(0, 10) : '';
    },
    
    formatarDataTexto(data) {
      if (data) {
        const date = new Date(data);
        return this.formatDateToBr(date);
      }
      return '';
    },

    valid() {
      this.validarFormulario = true;
      return this.state;
    },
    
    clear() {
      this.content = '';
      this.contentText = '';
      this.validarFormulario = false;
      this.hasError = false;
      this.erroData = false;
      this.$emit('input', '');
    },
    
    emitData() {
      this.$emit('input', this.content);
      this.$emit('change', this.content);
    },
  },
};
</script>

<style>
.is-valid button {
  border-color: #7dba19;
}
.is-invalid button {
  border-color: #dc3545;
}

.input-group {
  height: 40px;
}
</style>
